// removed by extract-text-webpack-plugin
module.exports = {"saas-poster-preview":"saas-poster-preview","preview-buttons":"preview-buttons","button":"button","edit":"edit","share":"share"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Poster/SaasPosterPreview/SaasPosterPreview.scss
// module id = lHNU
// module chunks = 0